import React, { FC, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../../config/firebase";
import Input from "../../UI/Input";
import Button from "../../UI/Button";
import Container from "react-bootstrap/Container";
import { FormControl } from "@mui/material";
import { toast } from "react-toastify";
import { validateEmail } from "../../../helpers/validation";

const ForgotPassword: FC = () => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");

    const navigate = useNavigate();

    const handleSendPasswordResetEmail = async (e: React.FormEvent): Promise<void> => {
        e.preventDefault();

        //Validate email before sending
        if (!validateEmail(email)) {
            setError("Pogrešan format email adrese.");
            return;
        }

        try {
            await sendPasswordResetEmail(auth, email);

            toast.success("Mejl za reset lozinke je uspešno poslat. Takođe, proverite i Spam folder.");
            navigate("/login");
        } catch (err: any) {
            toast.error("Došlo je do greške. Pokušajte ponovo kasnije.");
        }
    };

    return (
        <Container>
            <div className="auth_wraper">
                <div className="auth_box">
                    <div className="auth_header">
                        <h2>Zaboravljena lozinka</h2>
                    </div>
                    <div className="auth_form">
                        <Input
                            label="Email"
                            type="email"
                            value={email}
                            name="email"
                            required
                            error={error}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setError("");
                            }}
                        />
                        <FormControl sx={{ my: 1.5 }}>
                            <Button
                                label="Pošaljite mejl"
                                className="btn_success"
                                handleClick={handleSendPasswordResetEmail}
                            />
                        </FormControl>
                        <FormControl sx={{ display: "flex", mb: 2 }}>
                            <Link to="/login" className="login_register_link">
                                Nazad na prijavu
                            </Link>
                        </FormControl>
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default ForgotPassword;